import { render } from "./AddPlatform.vue?vue&type=template&id=0a0c4e64&scoped=true"
import script from "./AddPlatform.vue?vue&type=script&lang=js"
export * from "./AddPlatform.vue?vue&type=script&lang=js"

import "./AddPlatform.vue?vue&type=style&index=0&id=0a0c4e64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0c4e64"]])

export default __exports__